// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"1ac7cdce","164":"dd1d5e60","177":"70faad3f","304":"698d2b81","787":"b2c3f5bb","884":"c924f75f"}[chunkId] + ".chunk.js";
};